// extracted by mini-css-extract-plugin
export var chevron = "_f2-2";
export var dropdownItems = "_f2-0";
export var item = "_f2-1";